import React, { useEffect, useRef } from "react";

import EasyMDE from "easymde";

interface ReleaseNotesDetailsFormMarkdownEditorProps {
  value: string;
  onChange: (value: string) => void;
}

const ReleaseNotesDetailsFormMarkdownEditor: React.FC<
  ReleaseNotesDetailsFormMarkdownEditorProps
> = ({ value, onChange }) => {
  const textareaRef = useRef<HTMLTextAreaElement | null>(null);
  const editorRef = useRef<EasyMDE | null>(null);

  useEffect(() => {
    if (textareaRef.current) {
      editorRef.current = new EasyMDE({
        element: textareaRef.current,
        initialValue: value,
        autoDownloadFontAwesome: true,
        spellChecker: false,
        status: false,
        autofocus: true,
        maxHeight: "230px",
        toolbar: [
          "bold",
          "italic",
          {
            name: "headings",
            className: "fa fa-header",
            title: "Headings",
            children: [
              {
                name: "heading-1",
                action: EasyMDE.toggleHeading1,
                className: "fa fa-header header-1",
                title: "Big Heading"
              },
              {
                name: "heading-2",
                action: EasyMDE.toggleHeading2,
                className: "fa fa-header header-2",
                title: "Medium Heading"
              },
              {
                name: "heading-3",
                action: EasyMDE.toggleHeading3,
                className: "fa fa-header header-3",
                title: "Small Heading"
              }
            ]
          },
          "|",
          "quote",
          "unordered-list",
          "ordered-list",
          "|",
          "link",
          "code",
          "|",
          "guide"
        ],
        renderingConfig: {
          singleLineBreaks: false,
          codeSyntaxHighlighting: false
        },
        previewRender: plainText => plainText
      });

      editorRef.current.codemirror.on("change", () => {
        if (editorRef.current) {
          onChange(editorRef.current.value());
        }
      });
    }

    // this is to destroy the editor
    return () => {
      if (editorRef.current) {
        editorRef.current.toTextArea();
        editorRef.current = null;
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <textarea ref={textareaRef}></textarea>;
};

export default ReleaseNotesDetailsFormMarkdownEditor;
